import React from 'react';
import {BubbleEverywhere} from 'prophesier/dist/wrapper/index-with-deps-react.min.js';

const data = [{
    "ax": "03/29/2017 10:00 AM",
    "ay": 6.1,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/29/2017 11:00 AM",
    "ay": 6.5,
    "aValue": 15,
    "attempts": 10
}, {
    "ax": "03/29/2017 12:00 PM",
    "ay": 6.3,
    "aValue": 25,
    "attempts": 30
}, {
    "ax": "03/29/2017 1:00 PM",
    "ay": 6.9,
    "aValue": 55,
    "attempts": 20
}, {
    "ax": "03/29/2017 2:00 PM",
    "ay": 6.1,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/29/2017 3:00 PM",
    "ay": 6.5,
    "aValue": 25,
    "attempts": 10
}, {
    "ax": "03/29/2017 4:00 PM",
    "ay": 6.3,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/29/2017 5:00 PM",
    "ay": 6.9,
    "aValue": 25,
    "attempts": 30
}, {
    "ax": "03/29/2017 6:00 PM",
    "ay": 6.1,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/29/2017 7:00 PM",
    "ay": 6.5,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/29/2017 8:00 PM",
    "ay": 6.3,
    "aValue": 55,
    "attempts": 30
}, {
    "ax": "03/29/2017 9:00 PM",
    "ay": 6.9,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/29/2017 10:00 PM",
    "ay": 6.1,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/29/2017 11:00 PM",
    "ay": 6.5,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/30/2017 12:00 AM",
    "ay": 6.3,
    "aValue": 55,
    "attempts": 20
}, {
    "ax": "03/30/2017 1:00 AM",
    "ay": 6.9,
    "aValue": 25,
    "attempts": 10
}, {
    "ax": "03/30/2017 2:00 AM",
    "ay": 6.1,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/30/2017 3:00 AM",
    "ay": 6.5,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/30/2017 4:00 AM",
    "ay": 6.3,
    "aValue": 25,
    "attempts": 30
}, {
    "ax": "03/30/2017 5:00 AM",
    "ay": 6.9,
    "aValue": 15,
    "attempts": 20
}, {
    "ax": "03/30/2017 6:00 AM",
    "ay": 6.1,
    "aValue": 25,
    "attempts": 10
}, {
    "ax": "03/30/2017 7:00 AM",
    "ay": 6.5,
    "aValue": 25,
    "attempts": 10
}, {
    "ax": "03/30/2017 8:00 AM",
    "ay": 6.3,
    "aValue": 25,
    "attempts": 20
}, {
    "ax": "03/30/2017 9:00 AM",
    "ay": 6.9,
    "aValue": 25,
    "attempts": 30
}];

const names = ["10 Attempts", "20 Attempts", "30 Attempts"]

const colorPrim = ["rgb(91,100,114)", "rgb(196,175,84)", "rgb(86,130,216)"];

class BubbleSample extends React.Component {
    constructor() {
        super();
        this.state = { 
            title: true,
            legends: true,
            exprt: false
             }
    }
    render() {
        let { title, legends, exprt } = this.state
        return (
            <div>
                <h2><strong>Results</strong></h2>
                 <BubbleEverywhere
                    data={data}
                    names={names}
                    xformat={'date'}
                    barcolor={colorPrim}
                    xtitle={(title) ? 'Time': ''}
                    ytitle={(title) ? 'Title for Y':''}
                    exprt={exprt}
                    legends={legends}
                ></BubbleEverywhere>
            </div>
        );
    }
}

export default BubbleSample;



// WEBPACK FOOTER //
// ./src/samples/run/scatter.js